export default function () {

    const $config = useRuntimeConfig().public;

    async function getVideoPoster (src) {
        let error = null;
        let {filename, extension} = srcToParts(src);
        let posterURL = $config.uploads + 'videos-general/mp4/' + filename + '-00001.jpg';
        try {
            const {data} = await useApi('uploads').get('videos/name/' + filename + '/' + extension);
            if (data?.video?.video_poster) {
                posterURL = $config.uploads + data.video.video_poster;
            }
        } catch (e) {
            error = useApiError(e);
        }
        return {posterURL, error};
    }

    function srcToParts (src) {
        let sourceParts = src ? src.split('/') : [];
        let fileNameParts = sourceParts ? sourceParts[sourceParts.length - 1].split('.') : [];
        let filename = fileNameParts[fileNameParts.length - 2];
        let extension = fileNameParts[fileNameParts.length - 1];
        return {filename, extension};
    }

    return {getVideoPoster};
};
